import { createAction, props } from '@ngrx/store';

export const storageActions = {
  changed: createAction('[Store] Changed', props<{ readonly key: string; }>()),
};
